// extracted by mini-css-extract-plugin
export default {"filtersToggle":"style_filtersToggle__VwERn"};